var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.open)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.windowLoaded),expression:"windowLoaded"}],staticStyle:{"width":"100%","height":"100vh"}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }